import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import AddButton from "../../../../components/AddButton";
import CancelButton from "../../../../components/CancelButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import EditButton from "../../../../components/EditButton";
import SaveButton from "../../../../components/SaveButton";
import SelectInput from "../../../../components/SelectInput";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import TableFilters from "../TableFilters";
import { addStateCarrierProgram, editStateCarrierProgram } from "./atoms/atoms";
import useAddCarrierProgram from "./hooks/useAddCarrierProgram";
import { useCarrierProgram } from "./hooks/useCarrierProgram";
import useDeleteCarrierProgram from "./hooks/useDeleteCarrierProgram";
import useEditCarrierProgram from "./hooks/useEditCarrierProgram";
import { useQueryClient } from "react-query";
import { useGetCarriers } from "../../../CarrierAgreementMgmt/Carrier/hooks/useGetCarriers";
import { useHistory, useLocation } from "react-router-dom";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";

const CarrierProgramTable = () => {
  const queryClient = useQueryClient();
  const [addState, setAddState] = useRecoilState(addStateCarrierProgram);
  const [editState, setEditState] = useRecoilState(editStateCarrierProgram);
  const newRow = {
    programName: "",
    carrierId: 0,
    isActive: true,
  };

  const [newData, setNewData] = useState([newRow]);
  const [cProgramFilteredData, setCProgramFilteredData] = useState([]);
  const [cProgramData, setCProgramData] = useState([]);
  const [editRowData, setEditRowData] = useState();
  const [selectedRows, setSelectedRows] = useState();
  const [rowsCount, setRowsCount] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [disableSave, setDisableSave] = useState(true);
  const [confirmBox, setConfirmBox] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState(false);

  const programData = useCarrierProgram();
  const { mutateAsync: addCarrierProgram } = useAddCarrierProgram();
  const editCarrierProgram = useEditCarrierProgram();
  const deleteCarrierProgram = useDeleteCarrierProgram();

  const [, setLOBTypeFilteredData] = useState([]);
  const [, setProdCodeTypeFilteredData] = useState([]);
  const [, setMgaFilteredData] = useState([]);
  const [, setDisChannelFilteredData] = useState([]);
  const [, setCodeLevelFilteredData] = useState([]);

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_carrierprogram_edit;
  const hasAdd = PERMISSIONS.permission_utilities_carrierprogram_add;
  const hasDelete = PERMISSIONS.permission_utilities_carrierprogram_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  //DropDown Options
  const { data: carriers } = useGetCarriers();
  const carrierOptions = carriers
    ?.filter((x) => x.isActive === true)
    .map((x) => {
      return {
        label: x.carrierName,
        value: x.masterCarrierId,
      };
    });

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  //handle Add Button
  const handleAdd = () => {
    setDisableSave(true);
    setAddState(true);
    setUpdatedStatus(true);
  };

  //handle Edit Button
  const handleEdit = (rowData) => {
    setEditState(true);
    setEditRowData({ ...rowData });
  };
  //handle Save Button
  const handleSave = () => {
    setConfirmBox(false);
    if (addState) {
      addCarrierProgram(
        { ...newData },
        {
          onSuccess: (res) => {
            if (res.data === "duplicate") {
              toast.fire("Failed", "Carrier Program already exist", "error");
            } else if (res.status === 201) {
              setAddState(false);
              setNewData([newRow]);
              queryClient.invalidateQueries();
              toast.fire(
                "Success",
                "New Carrier Program added successfully",
                "success"
              );
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Carrier Program",
                "error"
              );
            }
          },
          onError: (error) => {
            if (
              error.response.data.message === "Failed sending of email" ||
              error.response.data.message === "Failed inserting of notification"
            ) {
              toast.fire(
                "Success",
                "New Carrier Program added successfully, but " +
                  error.response.data.message,
                "warning"
              );
              queryClient.invalidateQueries();
            } else {
              toast.fire(
                "Failed",
                "Server Error: Cannot add new Carrier Program",
                "error"
              );
            }
          },
        }
      );
    } else {
      //else for if c
      const programName = editRowData.programName.trim();
      const programDatas = cProgramData.filter(
        (x) => x.programName === programName
      );

      if (
        editRowData.carrierId === programDatas[0]?.carrierId &&
        programName === programDatas[0]?.programName &&
        editRowData.isActive === programDatas[0]?.isActive
      ) {
        toast.fire("Saving Failed", "No Changes have been made", "warning");
        setConfirmBox(false);
      } else {
        editCarrierProgram(editRowData);
      }
    }
  };
  //handle input fields changes
  const handlesFieldsChange = (fieldName, value) => {
    if (addState) {
      setNewData((data) => [{ ...data[0], [fieldName]: value }]);
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    } else {
      //else Edit State
      setEditRowData({ ...editRowData, [fieldName]: value });
      if (fieldName === "isActive") {
        value ? setUpdatedStatus(true) : setUpdatedStatus(false);
      }
    }
  };

  const handleCancel = () => {
    setEditState(false);
    setAddState(false);
    setEditRowData();
    setNewData([newRow]);
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive).map((del) => del.id);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  //Filter
  const [carrierProgId, setCarrierProgId] = useState("");
  useEffect(() => {
    if (filterText) {
      setCProgramData(
        programData.data.filter((x) =>
          x.programName.toLowerCase().includes(filterText.trim().toLowerCase())
        )
      );
    } else if (carrierProgId?.includes(".")) {
      let carrierProgIds = carrierProgId.split(".");
      const carrierProgIdsArr = carrierProgIds.map((id) => Number(id));
      const filteredData = programData.data?.filter((x) =>
        carrierProgIdsArr.includes(x.id)
      );

      setCProgramFilteredData(filteredData);
    } else if (cProgramFilteredData?.length === 1) {
      const filteredData = programData.data?.filter(
        (x) => x.id === Number(carrierProgId)
      );

      setCProgramFilteredData(filteredData);
    } else {
      setCProgramData(programData.data);
    }
    setEditState(false);
    setAddState(false);
  }, [filterText, programData.data]);

  const handleDelete = () => {
    deleteCarrierProgram(selectedRows);
    setOpenModalDelete(false);
    setSelectedRows([]);
  };

  //validation
  useEffect(() => {
    if (
      addState &&
      newData[0]?.programName?.trim() &&
      newData[0]?.carrierId > 0
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [newData[0]]);

  useEffect(() => {
    if (
      editState &&
      editRowData?.programName?.trim() &&
      editRowData?.carrierId > 0
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [editRowData]);

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setCProgramFilteredData(result);
          setCarrierProgId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
    setSelectedRows([]);
  }, []);

  const matColumns = [
    {
      title: "Id",
      field: "id",
      hidden: addState || editState,
      render: (rowData) => {
        return (
          <span className="text-quinary font-bold uppercase text-base">
            {rowData.id}
          </span>
        );
      },
    },
    {
      title: (
        <span className="w-full text-nowrap">
          Program Name{" "}
          <span className="requiredAsterisk">
            {(addState || editState) && "*"}
          </span>
        </span>
      ),
      field: "programName",
      align: "left",
      customSort: (a, b) =>
        a.programName && b.programName
          ? a.programName.trim().localeCompare(b.programName.trim())
          : a.programName
          ? 0
          : -1,
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="w-full">
            <div className="">
              <TextInput
                defaultValue={rowData.programName}
                onChange={(e) =>
                  handlesFieldsChange("programName", e.target.value)
                }
              />
            </div>
          </div>
        ) : (
          <div className="w-full">{rowData.programName}</div>
        );
      },
    },
    {
      title: (
        <span>
          Carrier{" "}
          <span className="requiredAsterisk">
            {(addState || editState) && "*"}
          </span>
        </span>
      ),
      field: "carrierName",
      align: "left",
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <SelectInput
            options={carrierOptions}
            defaultValue={carrierOptions?.filter(
              (x) => x.value === rowData.carrierId
            )}
            onChange={(selectedOptions) => {
              handlesFieldsChange("carrierId", selectedOptions?.value);
            }}
          />
        ) : (
          <div className="w-full">
            {carrierOptions &&
            carrierOptions.filter((x) => x.value === rowData.carrierId).length >
              0
              ? carrierOptions.filter((x) => x.value === rowData.carrierId)[0]
                  .label
              : ""}
          </div>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      align: "left",
      hidden: addState || editState,
    },
    {
      field: "createdOn",
      title: "Created Date",
      align: "left",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      align: "left",
      hidden: addState || editState,
      render: (rowData) => {
        return <div>{rowData.modifiedBy}</div>;
      },
    },
    {
      field: "modifiedOn",
      title: "Modified Date",
      align: "left",
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowData) => {
        return (
          <div className="w-full">
            {rowData.modifiedOn
              ? new Date(rowData.modifiedOn).toLocaleDateString()
              : ""}
          </div>
        );
      },
      hidden: addState || editState,
    },
    {
      field: "isActive",
      align: "left",
      title: <span>Status {addState || editState}</span>,
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handlesFieldsChange("isActive", e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {updatedStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      hidden: addState,
      render: (rowData) => {
        return (rowData.id === editRowData?.id && editState) || addState ? (
          <div className="flex justify-center space-x-1 ">
            <SaveButton
              buttonText="Save"
              disabled={
                disableSave ||
                (rowData?.programName === editRowData?.programName &&
                  rowData?.carrierId === editRowData?.carrierId &&
                  rowData?.isActive === editRowData?.isActive)
              }
              onClick={() => setConfirmBox(true)}
            />
            <CancelButton onClick={() => handleCancel()} />
          </div>
        ) : (
          <div className=" grid grid-col-1 justify-items-center mr-4">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={selectedRows?.length > 0 || editState}
                className={
                  selectedRows?.length > 0 || editState
                    ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
                    : "opacity-100 rounded-full  items-center bg-quaternary  text-white hover:bg-hquaternary"
                }
                onClick={() => handleEdit(rowData)}
              />
            )}
          </div>
        );
      },
    },
  ];

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Carrier Programs" : "Carrier Program"
    }?`}</div>
  );

  return (
    <div className="bg-white p-4 ">
      {!addState && (
        <div>
          <div className="flex flex-row justify-between items-center">
            <TableFilters
              setMgaFilteredData={setMgaFilteredData}
              setCProgramFilteredData={setCProgramFilteredData}
              setLOBTypeFilteredData={setLOBTypeFilteredData}
              setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
              setDisChannelFilteredData={setDisChannelFilteredData}
              setCodeLevelFilteredData={setCodeLevelFilteredData}
              setFilterText={setFilterText}
              placeholder="Carrier Program"
              disabledButton={editState || selectedRows?.length > 0}
            />

            <div className="">
              {userPermissions.includes(hasAdd) ? (
                <AddButton
                  buttonText="New Carrier Program"
                  className={
                    selectedRows?.length > 0 || editState
                      ? "opacity-50 float-right"
                      : "opacity-50 float-right"
                  }
                  onClick={() => handleAdd()}
                  disabled={selectedRows?.length > 0 || editState}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div>
            {userPermissions.includes(hasDelete) ? (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note:</p>
                <span>Tick the box to deactivate some data.</span>
              </div>
            ) : (
              <div className="mb-4"></div>
            )}
          </div>
        </div>
      )}
      <div
        className={
          addState ? " px-3 py-2 border-l-2  border-primary box-shadow" : ""
        }
      >
        {addState && (
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold">
                Add New Carrier Program
              </div>
              <div className="flex items-center space-x-2 pt-2">
                <SaveButton
                  buttonText="Save"
                  disabled={disableSave}
                  onClick={() => setConfirmBox(true)}
                />
                <CancelButton onClick={() => handleCancel()} />
              </div>
            </div>
            <div className=" h-0.5 w-full border-b-2 border-secondary " />
          </div>
        )}
        <div className={addState ? "py-2" : ""}>
          <MaterialProducerCodeConfigTable
            data={
              addState
                ? newData
                : cProgramFilteredData?.length > 0
                ? cProgramFilteredData
                : cProgramData
            }
            isLoading={programData.isFetching}
            columns={matColumns}
            selection={
              !addState && !editState && userPermissions.includes(hasDelete)
            }
            selectedRows={selectedRows}
            setOpenModal={setOpenModalDelete}
            paging={!addState}
            onSelectionChange={handleSelectedRowsChange}
          />
          <ConfirmBoxModal
            ModalTitle={
              addState ? "Add Carrier Program" : "Update Carrier Program"
            }
            qConfirmation={
              addState
                ? "Are you sure you want to add this?"
                : "Are you sure you want to update this?"
            }
            isOpen={confirmBox}
            onClose={() => setConfirmBox(false)}
            onClickFunction={() => {
              handleSave();
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Carrier Program"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={() => {
              handleDelete();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CarrierProgramTable;
